// Shared style tokens for the Clients feature (increment 5 UI). Keeps Field / TaskDetail /
// ClientPage visually consistent without repeating inline objects.
import { colors, font } from "../utils/theme.js";

export const inputStyle = {
  width: "100%", padding: "8px 10px", background: colors.bg, border: `1px solid ${colors.borderLight}`,
  borderRadius: 6, color: colors.text, fontSize: 13, fontFamily: font, outline: "none", boxSizing: "border-box",
};
export const section = { background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 20, marginBottom: 16 };
export const labelStyle = { fontSize: 11, fontWeight: 700, color: colors.textDim, letterSpacing: 1, textTransform: "uppercase" };
export const primaryBtn = { padding: "7px 14px", background: colors.accent, border: "none", borderRadius: 6, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: font };
export const ghostBtn = { padding: "7px 14px", background: "transparent", border: `1px solid ${colors.borderLight}`, borderRadius: 6, color: colors.textMuted, fontSize: 13, cursor: "pointer", fontFamily: font };
export const editBtn = { background: "none", border: "none", color: colors.accent, fontSize: 12, cursor: "pointer", fontFamily: font, padding: 0, whiteSpace: "nowrap" };
export const linkBtn = { background: "none", border: "none", color: colors.accent, fontSize: 12, cursor: "pointer", fontFamily: font, padding: 0 };

export const STATUSES = ["Not Started", "In Progress", "Blocked", "Completed"];
export const STATUS_STYLE = {
  "Not Started": { color: colors.textDim, bg: colors.surfaceAlt },
  "In Progress": { color: "#93c5fd", bg: "rgba(59,130,246,0.14)" },
  "Blocked": { color: "#fcd34d", bg: "rgba(245,158,11,0.14)" },
  "Completed": { color: "#a7f3d0", bg: "rgba(16,185,129,0.14)" },
};
